import {useState} from 'react'
import {toast} from 'react-toastify'
import {NumericFormat} from 'react-number-format'
import {useIntl} from 'react-intl'
import {currency} from 'src/feature/bite/helpers/currency'

const InputsLangs = () => {
  const intl = useIntl()

  const inputs = [
    {
      key: 'min',
      ruleId: ['1', '6', '8'],
      discountControlRule: '1', // 1: Moneraty
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.MIN_SPENDING'})}</label>
          <NumericFormat
            min={0}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MIN_SPENDING'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
            decimalScale={2}
          />
        </div>
      ),
    },
    {
      key: 'max',
      ruleId: ['1', '6', '8'],
      discountControlRule: '1', // 1: Moneraty
      label: intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'}),
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'})}</label>
          <NumericFormat
            min={0}
            max={1000000}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
            decimalScale={2}
          />
        </div>
      ),
    },

    {
      key: 'quantity',
      ruleId: ['3'],
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.QUANTITY'})}</label>
          <NumericFormat
            type='text'
            min={0}
            max={1000000}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.QUANTITY'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
          />
        </div>
      ),
    },
    {
      key: 'min',
      ruleId: ['2', '4', '5', '6', '7', '15'],
      discountControlRule: '2', // 2: Quentitive
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.MIN_QUANTITY'})}</label>
          <NumericFormat
            min={0}
            max={1000000}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MIN_QUANTITY'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
          />
        </div>
      ),
    },
    {
      key: 'max',
      ruleId: ['2', '4', '5', '6', '7', '15'],
      discountControlRule: '2', // 2: Quentitive
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.MAX_QUANTITY'})}</label>
          <NumericFormat
            type='text'
            min={0}
            max={1000000}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MAX_QUANTITY'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
          />
        </div>
      ),
    },
    {
      key: 'freeQuantity',
      ruleId: ['5', '6', '7', '15'],
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>{intl.formatMessage({id: 'GLOBAL.INPUT.FREE_QUANTITY'})}</label>
          <NumericFormat
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.FREE_QUANTITY'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
          />
        </div>
      ),
    },
    {
      key: 'productCategory',
      ruleId: ['7'],
      render: (Field: any, value: string, onChange: any, values: any, rewardType: number) => (
        <div className='w-100'>
          <label className='mb-2'>
            {intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_PRODUCT_CATEGORY'})}
          </label>
          <Field
            type='select'
            as='select'
            className='form-control form-select form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_PRODUCT_CATEGORY'})}
            value={value}
            onChange={onChange}
          >
            <option disabled>Select Product Category</option>
            <option value='1'>...</option>
          </Field>
        </div>
      ),
    },
    {
      key: 'rewardType',
      // ruleId: ['1', '2', '3', '4', '5', '6', '7'],
      ruleId: ['1', '4', '5', '6', '7', '15'],
      render: (Field: any, value: string, onChange: any, values: any, rewardType: number) => {
        const disabled = values.priceCluster?.length > 0
        const defaultRewardType =
          values.priceCluster?.length > 0 ? values.priceCluster[0].rewardType : null

        return (
          <div className='w-100'>
            <label className='mb-2'>
              {intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
            </label>
            <Field
              type='select'
              as='select'
              className='form-control form-select form-control-sm form-control-solid'
              placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
              value={defaultRewardType || value}
              onChange={onChange}
              disabled={disabled}
            >
              <option disabled>{intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}</option>
              {/* <option value='1'>{intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_AMOUNT'})}</option>
            <option value='2'>{intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_AMOUNT'})}</option> */}

              <option
                value='2'
                // disabled={values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 1}
              >
                {intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_AMOUNT.2'})}
              </option>
              <option
                value='1'
                // disabled={values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 2}
              >
                {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_AMOUNT.2'})}
              </option>
            </Field>
          </div>
        )
      },
    },
    {
      key: 'value',
      ruleId: ['1', '2', '3', '4', '5', '6', '7', '15'],
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>
            {intl.formatMessage({id: 'GLOBAL.INPUT.VALUE'})}
            {rewardType === 1 ? <span> (%)</span> : <span> ($)</span>}
          </label>
          <NumericFormat
            min={0}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.VALUE'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
            decimalScale={2}
          />
        </div>
      ),
    },
    {
      key: 'percentageValue',
      ruleId: [],
      render: (
        Field: any,
        value: string | number,
        onChange: any,
        values: any,
        rewardType: number
      ) => (
        <div className='w-100'>
          <label className='mb-2'>
            {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_VALUE'})}
          </label>
          <NumericFormat
            min={0}
            className='form-control form-control-sm form-control-solid'
            placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_VALUE'})}
            value={!value || value === 0 ? '' : value}
            onChange={onChange}
            maxLength={6}
            allowLeadingZeros={false}
            allowNegative={false}
          />
        </div>
      ),
    },
  ]

  return inputs
}

const IncrementedPoints = ({Field, values, setFieldValue}: any) => {
  const intl = useIntl()

  return (
    <div className='mt-10 mb-6'>
      <div className='d-flex align-items-top justify-content-between gap-5'>
        <div className='d-flex flex-column w-100'>
          <div className='input-group input-group-solid w-100'>
            <NumericFormat
              name='pointsToBeEarned'
              placeholder='e.g. 10'
              className='form-control form-control-sm form-control-solid'
              aria-label='pointsToBeEarned'
              aria-describedby='basic-addon2'
              value={values.pointsToBeEarned === '0' ? '' : values.pointsToBeEarned}
              onChange={(e: any) => setFieldValue('pointsToBeEarned', e.target.value)}
              allowNegative={false}
              allowLeadingZeros={false}
              maxLength={10}
              decimalScale={2}
            />

            <span className='input-group-text' id='basic-addon2'>
              {intl.formatMessage({id: 'CAMPAIGN.POINT.POINTS'})}
            </span>
          </div>

          {values?.pointsToBeEarned && values?.pointsToBeEarned > 1000000 ? (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
            </div>
          ) : null}
          {values.pointsToBeEarned < 0 && (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
            </div>
          )}
        </div>
        <span style={{whiteSpace: 'nowrap', marginTop: 12}}>
          {intl.formatMessage({id: 'CAMPAIGN.POINT.FOR_EVERY'})}
        </span>
        <div className='d-flex flex-column w-100'>
          <div className='input-group input-group-solid w-100'>
            <NumericFormat
              name='amountToBeSpent'
              className='form-control form-control-sm form-control-solid'
              aria-label='amountToBeSpent'
              aria-describedby='basic-addon3'
              value={values.amountToBeSpent === '0' ? '' : values.amountToBeSpent}
              placeholder='e.g. 10'
              onChange={(e: any) => setFieldValue('amountToBeSpent', e.target.value)}
              allowNegative={false}
              allowLeadingZeros={false}
              maxLength={10}
              decimalScale={2}
            />
            <span className='input-group-text' id='basic-addon3'>
              {intl.formatMessage({id: 'CAMPAIGN.POINT.AMOUNT'})}
            </span>
          </div>

          {values?.amountToBeSpent && values?.amountToBeSpent > 1000000 ? (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
            </div>
          ) : null}
          {values.amountToBeSpent < 0 && (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
            </div>
          )}
        </div>
      </div>
      <label className='form-label fw-bold mt-4'>
        {intl.formatMessage(
          {id: 'CAMPAIGN.POINT.FOR_EVERY_SPENT'},
          {spent: currency(values.amountToBeSpent), point: values.pointsToBeEarned}
        )}
      </label>
    </div>
  )
}

const FixedAmount = ({Field, values, setFieldValue, disabled}: any) => {
  const intl = useIntl()

  const lockType = values.priceCluster?.length > 0 ? values.priceCluster[0].rewardType : ''

  const [priceCluster, setPriceCluster] = useState<{
    min?: number
    max?: number
    rewardType?: number
    value?: number
  }>({
    min: 0,
    max: 0,
    rewardType: 5,
    value: 0,
  })

  const onChange = (e: any, key: string) => {
    setPriceCluster({...priceCluster, [key]: Number(e.target.value)})
  }

  const onAdd = (e: any) => {
    e.preventDefault()

    // Check cluster limit first
    if (values.priceCluster?.length >= 3) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.MAX_CLUSTER_LIMIT'}))
      return
    }

    let samePriceCluster = false
    let diffPriceCluster = false

    const min = priceCluster.min
    const max = priceCluster.max

    if (priceCluster.rewardType === 4 && priceCluster?.value && priceCluster?.value >= 101) {
      return
    }

    if (min && max) {
      const betweenMinAndMax = values.priceCluster?.some((price: any) => {
        return (min >= price.min && min <= price.max) || (max >= price.min && max <= price.max)
      })

      if (betweenMinAndMax) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.BETWEEN_MIN_MAX'}))
        return
      }
    }

    if (values.priceCluster?.length > 0 && lockType !== priceCluster.rewardType) {
      diffPriceCluster = true
    }

    if (
      !priceCluster.min ||
      priceCluster.min <= 0 ||
      priceCluster.min > 1000000 ||
      !priceCluster.max ||
      priceCluster.max <= 0 ||
      priceCluster.max > 1000000 ||
      !priceCluster.rewardType ||
      priceCluster.rewardType === 0 ||
      !priceCluster.value ||
      priceCluster.value <= 0 ||
      priceCluster.value > 1000000
    ) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.FILL_ALL_FIELDS'}))
      return
    }

    if (priceCluster.min >= priceCluster.max || priceCluster.min === priceCluster.max) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.MIN_GREATER_THAN_MAX'}))
      return
    }

    if (priceCluster.rewardType == 2 && priceCluster?.value >= 101) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.PERCENTAGE_VALUE'}))
      return
    }

    values.priceCluster?.forEach((price: any) => {
      if (JSON.stringify(price) === JSON.stringify(priceCluster)) {
        samePriceCluster = true
      }
    })

    if (samePriceCluster) {
      // toast.error('This price cluster already exists')
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.PRICE_CLUSTER_EXISTS'}))
      return
    }

    if (diffPriceCluster) {
      // toast.error('You can only add one type of discount')
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.ONLY_ONE_DISCOUNT'}))
      return
    }
    setFieldValue('priceCluster', [...values.priceCluster, priceCluster])

    setPriceCluster({
      rewardType: priceCluster.rewardType,
      min: 0,
      max: 0,
      value: 0,
    })
  }

  const disabledType = values.priceCluster?.length > 0
  const defaultRewardType =
    values.priceCluster?.length > 0 ? values.priceCluster[0].rewardType : null

  return (
    <>
      {!disabled && (
        <>
          <div className='d-flex align-items-top justify-content-between gap-5 mt-10 mb-6'>
            <div className='w-100'>
              <div>
                <label className='mb-2'>
                  {intl.formatMessage({id: 'GLOBAL.INPUT.MIN_SPENDING'})}
                </label>
                <NumericFormat
                  className='form-control form-control-sm form-control-solid'
                  placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MIN_SPENDING'})}
                  value={priceCluster.min === 0 ? '' : priceCluster.min}
                  onChange={(e: any) => onChange(e, 'min')}
                  maxLength={6}
                  allowLeadingZeros={false}
                  allowNegative={false}
                  decimalScale={2}
                />
              </div>

              {priceCluster?.min && priceCluster?.min > 1000000 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
                </div>
              ) : null}
              {priceCluster?.min && priceCluster?.max ? (
                <>
                  {Number(priceCluster?.min) >= Number(priceCluster?.max) && (
                    <div className='text-danger' style={{marginTop: 5}}>
                      {intl.formatMessage({id: 'GLOBAL.ERROR.MIN_GREATER_THAN_MAX'})}
                    </div>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>

            <div className='w-100'>
              <label className='mb-2'>
                {intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'})}
              </label>
              <NumericFormat
                className='form-control form-control-sm form-control-solid'
                // placeholder='Max Spending'
                placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'})}
                value={priceCluster.max === 0 ? '' : priceCluster.max}
                onChange={(e: any) => onChange(e, 'max')}
                maxLength={6}
                allowLeadingZeros={false}
                allowNegative={false}
                decimalScale={2}
              />

              {priceCluster?.max && priceCluster?.max > 1000000 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
                </div>
              ) : null}

              {priceCluster?.max && priceCluster?.max < 0 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
                </div>
              ) : null}
            </div>

            <div className='w-100'>
              <label className='mb-2'>
                {intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
              </label>
              <Field
                type='select'
                as='select'
                disabled={disabledType}
                className='form-control form-select form-control-sm form-control-solid'
                // placeholder='Select an option'
                placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
                value={defaultRewardType || priceCluster.rewardType}
                onChange={(e: any) => onChange(e, 'rewardType')}
              >
                <option disabled>
                  {intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
                </option>
                <option
                  value='5'
                  disabled={
                    values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 1
                  }
                >
                  {intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_AMOUNT'})}
                </option>
                <option
                  value='4'
                  disabled={
                    values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 2
                  }
                >
                  {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_AMOUNT'})}
                </option>
              </Field>
            </div>

            <div className='w-100'>
              <label className='mb-2'>
                {priceCluster.rewardType === 4 ? (
                  <span> {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_OF_VALUE'})} (%)</span>
                ) : (
                  <span>{intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_POINT'})} </span>
                )}
              </label>
              <NumericFormat
                className='form-control form-control-sm form-control-solid'
                placeholder={intl.formatMessage({id: 'GLOBAL.INPUT.VALUE'})}
                value={priceCluster.value === 0 ? '' : priceCluster.value}
                onChange={(e: any) => onChange(e, 'value')}
                allowLeadingZeros={false}
                allowNegative={false}
                maxLength={6}
                decimalScale={2}
              />

              {priceCluster?.value && priceCluster?.value > 1000000 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
                </div>
              ) : null}
              {priceCluster?.value && priceCluster?.value < 0 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
                </div>
              ) : null}

              {priceCluster.rewardType === 4 &&
              priceCluster?.value &&
              priceCluster?.value >= 101 ? (
                <div className='text-danger' style={{marginTop: 5}}>
                  {intl.formatMessage({id: 'GLOBAL.ERROR.PERCENTAGE_VALUE'})}
                </div>
              ) : null}
            </div>

            <div>
              <label className='mb-2'>&nbsp;</label>
              <button className='btn btn-sm btn-primary' onClick={onAdd}>
                {intl.formatMessage({id: 'GLOBAL.BUTTON.ADD'})}
              </button>
            </div>
          </div>
          <div
            style={{
              height: values.priceCluster?.length > 0 ? '1px' : '0px',
              backgroundColor: '#e4e6ef',
            }}
          ></div>
        </>
      )}

      {values.priceCluster?.map((price: any, index: number) => {
        return (
          <>
            <div
              className='d-flex align-items-center justify-content-between gap-5 mt-10 mb-4'
              key={index}
            >
              <div className='input-group-solid w-100'>
                <label className='mb-2'>
                  {intl.formatMessage({id: 'GLOBAL.INPUT.MIN_SPENDING'})}
                </label>
                <Field
                  type='text'
                  disabled
                  className='form-control form-control-sm form-control-solid'
                  placeholder='Min Spending'
                  value={price.min}
                  // onChange={(e: any) => {
                  //   const newPriceCluster = values.priceCluster
                  //   newPriceCluster[index].min = e.target.value

                  //   setFieldValue('priceCluster', newPriceCluster)
                  // }}
                />
              </div>

              <div className='input-group-solid w-100'>
                <label className='mb-2'>
                  {intl.formatMessage({id: 'GLOBAL.INPUT.MAX_SPENDING'})}
                </label>
                <Field
                  type='text'
                  disabled
                  className='form-control form-control-sm form-control-solid'
                  placeholder='Max Spending'
                  value={price.max}
                />
              </div>

              <div className='input-group-solid w-100'>
                <label className='mb-2'>
                  {intl.formatMessage({id: 'GLOBAL.INPUT.SELECT_AN_OPTION'})}
                </label>
                <Field
                  type='select'
                  disabled
                  as='select'
                  className='form-control form-select form-control-sm form-control-solid'
                  placeholder='Select an option'
                  value={price.rewardType}
                >
                  <option
                    value='5'
                    disabled={
                      values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 1
                    }
                  >
                    {intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_AMOUNT'})}
                  </option>
                  <option
                    value='4'
                    disabled={
                      values.priceCluster?.length > 0 && values.priceCluster[0].rewardType !== 2
                    }
                  >
                    {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_AMOUNT'})}
                  </option>
                </Field>
              </div>

              <div className='input-group-solid w-100'>
                <label className='mb-2'>
                  {priceCluster.rewardType === 4 ? (
                    <span> {intl.formatMessage({id: 'GLOBAL.INPUT.PERCENTAGE_OF_VALUE'})} (%)</span>
                  ) : (
                    <span>{intl.formatMessage({id: 'GLOBAL.INPUT.FIXED_POINT'})} </span>
                  )}
                </label>
                <Field
                  disabled
                  type='text'
                  className='form-control form-control-sm form-control-solid'
                  placeholder='Value'
                  value={price?.value}
                />
              </div>

              {!disabled && (
                <div>
                  <label className='mb-2'>&nbsp;</label>
                  <button
                    className='btn btn-sm border border-secondary'
                    onClick={(e) => {
                      e.preventDefault()
                      setFieldValue(
                        'priceCluster',
                        values.priceCluster.filter((_, i) => i !== index)
                      )
                    }}
                  >
                    {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
                  </button>
                </div>
              )}
            </div>

            <div className='fw-bold text-black mt-2 mb-4'>
              {price.rewardType === 4 ? (
                <span>
                  {' '}
                  {intl.formatMessage(
                    {id: 'GLOBAL.INPUT.SAMPLE_PERCENTAGE'},
                    {
                      min: price.min,
                      max: price.max,
                      value: price.value,
                    }
                  )}
                </span>
              ) : (
                <span>
                  {' '}
                  {intl.formatMessage(
                    {id: 'GLOBAL.INPUT.SAMPLE_FIXED'},
                    {
                      min: price.min,
                      max: price.max,
                      value: price.value,
                    }
                  )}
                </span>
              )}
            </div>
          </>
        )
      })}
    </>
  )
}

const Discount = ({Field, values, setFieldValue, disabled}: any) => {
  const intl = useIntl()

  // const defaultType = values.promoGroup === '2' ? 2 : 1
  const lockType = values.priceCluster?.length > 0 ? values.priceCluster[0].type : 2

  const [priceCluster, setPriceCluster] = useState<{
    min: number
    max: number
    recursive: number
    freeQuantity: number
    categoryList: string[]
    productList: string[]
    rewardType: number
    value: number
  }>({
    min: 0,
    max: 0,
    recursive: 0,
    freeQuantity: 0,
    categoryList: [],
    productList: [],
    rewardType: 2,
    value: 0,
  })

  let inputs = InputsLangs().filter((input) => input.ruleId.includes(values.promoGroup))

  inputs = inputs.filter((input) => {
    if (
      values?.promoGroup === '6' &&
      input.discountControlRule &&
      input.discountControlRule !== values.discountControlType
    )
      return false

    return true
  })

  const onAdd = (e: any) => {
    e.preventDefault()

    // Check cluster limit first
    if (values.priceCluster?.length >= 3) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.MAX_CLUSTER_LIMIT'}))
      return
    }

    if (values.promoGroup === '1' && priceCluster.rewardType === 2) {
      if (priceCluster.min <= priceCluster.value) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.FIXED_REWARD_TYPE'}))
        return
      }
    }

    if (values.promoGroup === '5') {
      if (priceCluster.min < priceCluster.freeQuantity) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.MIN_GREATER_THAN_FREE'}))
        return
      }
    }

    // check inputs validation for values promoCluster
    let filled: string[] = []
    let samePriceCluster = false
    let diffPriceCluster = false

    if (values.priceCluster?.length > 0 && lockType && lockType !== priceCluster.rewardType) {
      diffPriceCluster = true
    }

    if (values.promoGroup !== '3') {
      const betweenMinAndMax = values.priceCluster?.some((price: any) => {
        return (
          (priceCluster.min >= price.min && priceCluster.min <= price.max) ||
          (priceCluster.max >= price.min && priceCluster.max <= price.max)
        )
      })

      if (betweenMinAndMax) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.BETWEEN_MIN_MAX'}))
        return
      }

      if (
        !priceCluster.min ||
        priceCluster.min <= 0 ||
        priceCluster.min > 1000000 ||
        !priceCluster.max ||
        priceCluster.max <= 0 ||
        priceCluster.max > 1000000 ||
        !priceCluster.rewardType ||
        priceCluster.rewardType === 0 ||
        !priceCluster.value ||
        priceCluster.value <= 0 ||
        priceCluster.value > 1000000
      ) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.FILL_ALL_FIELDS'}))
        return
      }

      if (priceCluster.min > priceCluster.max || priceCluster.min === priceCluster.max) {
        toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.MIN_GREATER_THAN_MAX'}))
        return
      }
    }

    if (priceCluster.rewardType == 1 && priceCluster.value >= 101) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.PERCENTAGE_VALUE'}))
      return
    }

    values.priceCluster?.forEach((price: any) => {
      if (JSON.stringify(price) === JSON.stringify(priceCluster)) {
        samePriceCluster = true
      }
    })

    inputs.forEach((input) => {
      if (input?.ruleId?.includes(values?.promoCluster)) {
        if (!priceCluster[input.key] || priceCluster[input.key] === '') {
          filled = [...filled, input.key]
        }
      }
    })

    if (filled.length > 0) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.FILL_ALL_FIELDS'}))
      return
    }

    if (samePriceCluster) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.PRICE_CLUSTER_EXISTS'}))
      return
    }

    if (diffPriceCluster) {
      toast.error(intl.formatMessage({id: 'GLOBAL.ERROR.ONLY_ONE_DISCOUNT'}))
      return
    }

    setFieldValue('priceCluster', [...values.priceCluster, priceCluster])

    setPriceCluster({
      min: 0,
      max: 0,
      recursive: 0,
      freeQuantity: 0,
      categoryList: [],
      productList: [],
      rewardType: priceCluster.rewardType || 1,
      value: 0,
    })
  }

  const activeRewardType =
    values.priceCluster?.length > 0 ? values.priceCluster[0].rewardType : priceCluster.rewardType

  return (
    <>
      {!disabled && (
        <>
          <div className='d-flex align-items-start mt-10 w-100 gap-5 mb-4'>
            {inputs.map((input, index) => {
              return (
                <div className='w-100' key={index}>
                  <div className='input-group input-group-solid w-100'>
                    {input.render(
                      Field,
                      priceCluster[input.key],
                      (e: any) =>
                        setPriceCluster({...priceCluster, [input.key]: Number(e.target.value)}),
                      values,
                      activeRewardType
                    )}
                  </div>

                  {priceCluster[input.key] > 1000000 && (
                    <div className='text-danger' style={{marginTop: 5}}>
                      {intl.formatMessage(
                        {id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'},
                        {length: '100,000'}
                      )}
                    </div>
                  )}
                  {priceCluster[input.key] < 0 && (
                    <div className='text-danger' style={{marginTop: 5}}>
                      {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
                    </div>
                  )}
                  {input.key === 'min' && priceCluster?.min && priceCluster?.max ? (
                    <>
                      {Number(priceCluster?.min) >= Number(priceCluster?.max) && (
                        <div className='text-danger' style={{marginTop: 5}}>
                          {intl.formatMessage({id: 'GLOBAL.ERROR.MIN_GREATER_THAN_MAX'})}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              )
            })}
            <div className=''>
              <label className='mb-2'>&nbsp;</label>
              <button className='btn btn-sm btn-primary' onClick={onAdd}>
                {intl.formatMessage({id: 'GLOBAL.BUTTON.ADD'})}
              </button>
            </div>
          </div>

          <div
            style={{
              height: values.priceCluster?.length > 0 ? '1px' : '0px',
              backgroundColor: '#e4e6ef',
            }}
          ></div>
        </>
      )}

      <div className='mb-4'>
        {values.priceCluster?.map((price: any, index: number) => {
          return (
            <div
              className='d-flex align-items-center mt-10 w-100 gap-5'
              key={`priceCluster-${index}`}
            >
              {inputs.map((input, index) => {
                return (
                  <div className='w-100' key={index}>
                    <div className='input-group input-group-solid w-100'>
                      {input.render(
                        Field,
                        price[input.key],
                        (e: any) => {},
                        values,
                        activeRewardType
                      )}
                    </div>
                  </div>
                )
              })}

              {!disabled && (
                <div>
                  <label className='mb-2'>&nbsp;</label>
                  <button
                    className='btn btn-sm border border-secondary'
                    onClick={(e) => {
                      e.preventDefault()
                      setFieldValue(
                        'priceCluster',
                        values.priceCluster.filter((_, i) => i !== index)
                      )
                    }}
                  >
                    {intl.formatMessage({id: 'GLOBAL.BUTTON.DELETE'})}
                  </button>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}

const FixedValuePoints = ({Field, values, setFieldValue}: any) => {
  const intl = useIntl()

  return (
    <div className='mt-0 mb-6'>
      <label className='form-label fw-bold'>
        {intl.formatMessage({id: 'CAMPAIGN.POINT.FIXED_POINTS'})}
      </label>

      <div className='mb-4'>{intl.formatMessage({id: 'CAMPAIGN.POINT.FIXED_POINTS.SUB'})}</div>

      <div className='d-flex align-items-top justify-content-between gap-5'>
        <div className='d-flex flex-column w-100'>
          <div className='input-group input-group-solid w-100'>
            <NumericFormat
              name='fixedValue'
              placeholder='Points Spent'
              className='form-control form-control-sm form-control-solid'
              aria-label='fixedValue'
              aria-describedby='basic-addon2'
              value={values.fixedValue}
              onChange={(e: any) => setFieldValue('fixedValue', e.target.value)}
              maxLength={7}
              allowLeadingZeros={false}
              allowNegative={false}
              decimalScale={0}
            />

            <span className='input-group-text' id='basic-addon2'>
              {intl.formatMessage({id: 'CAMPAIGN.POINT.POINTS'})}
            </span>
          </div>
          {values?.fixedValue && values?.fixedValue > 1000000 ? (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT'}, {length: '100,000'})}
            </div>
          ) : null}
          {values.fixedValue < 0 && (
            <div className='text-danger' style={{marginTop: 5}}>
              {intl.formatMessage({id: 'GLOBAL.ERROR.NEGATIVE_VALUE'})}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default function useEarningTypes() {
  const sectionRender = (Field: any, values: any, setFieldValue: any, disabled: boolean) => {
    if (values.promoCluster === '9') {
      return <FixedValuePoints Field={Field} values={values} setFieldValue={setFieldValue} />
    }

    switch (values.promoGroup) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
      case '10':
      case '15':
        return (
          <Discount
            Field={Field}
            values={values}
            setFieldValue={setFieldValue}
            disabled={disabled}
          />
        )
      case '11':
        if (values.campaignType === '11')
          return (
            <IncrementedPoints
              Field={Field}
              values={values}
              setFieldValue={setFieldValue}
              disabled={disabled}
            />
          )
        return (
          <FixedAmount
            Field={Field}
            values={values}
            setFieldValue={setFieldValue}
            disabled={disabled}
          />
        )
      default:
        return <></>
    }
  }
  return {sectionRender}
}
